import APIConfig from '../apiconfig';

export const shouldShowFreeTrialInConsole = (): boolean => {
  return APIConfig.showFreeTrialInConsole;
};
